module.exports = __webpack_public_path__ + "img/w23b.fb8659e9.jpg";